import { useState, useEffect, useRef } from "react";
import "./TestimonialContent.css";
import PlayButton from "./PlayButton";
import { LazyLoadImage } from 'react-lazy-load-image-component';

const TestimonialContent = (props: any) => {
    const vidRef = useRef<HTMLVideoElement>(null);

    const {
        children,
        mediaUrl,
        personName,
        personDesignation,
        companyName,
        mediaType,
    } = props; //22

    const handlePlayVideo = () => {
        if (vidRef.current) {
            vidRef.current.play();
        }
    };

    const [screenSize, setScreenSize] = useState<any>(window.innerWidth);

    useEffect(() => {
      const handleResize = () => {
        setScreenSize(window.innerWidth);
      };
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);

    return (
        <div className="testimonialContent">

            {mediaType === "video" && (
                <div className="VideoSection">
                    <video
                        loop
                        muted
                        className="testimonialBanner"
                        ref={vidRef}
                    >
                        <source src={mediaUrl} />
                    </video>

                    <div className="testimonialContentOverlay">
                        <div className="testimonialContentBackdrop"></div>
                        <div className="testimonialContentTitle">
                            <h1>{companyName}</h1>
                        </div>
                        <div
                            className="testimonialContentPlayButton"
                            onClick={handlePlayVideo}
                        >
                            <PlayButton />
                        </div>
                        <div className="testimonialContentPersonDetails">
                            <div className="testimonialContentPersonName">
                                {personName}
                            </div>
                            <div className="testimonialContentPersonDesignation">
                                {personDesignation}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {mediaType === "image" && (
                <div className="ImageSection">
                    {mediaUrl && (
                        <LazyLoadImage src={mediaUrl} alt="testimonial-banner" />
                    )}
                    <div className="testimonialContentOverlay">
                        <div className="testimonialContentBackdrop"></div>
                        <div className="testimonialContentPersonDetails">
                            <div className={"testimonialContentPersonName"}>
                                {personName}
                            </div>
                            <div className={"testimonialContentPersonCompanyName"}>
                                {companyName}
                            </div>
                        </div>
                        <div className="testimonialContentImageTitle">
                            <h1>{personDesignation}</h1>
                        </div>
                        <div className={`${screenSize > 600 ? 'testimonialContentDescription' : 'testimonialContentDescription_mobile'}`}>
                            {children}
                        </div>
                    </div>
                </div>
            )}

            {mediaType === "youtube" && (
                <div className="VideoSection">
                    {" "}
                    <iframe
                        title="youtube"
                        className="testimonialBanner"
                        src={mediaUrl}
                    ></iframe>
                </div>
            )}
        </div>
    );
};

export default TestimonialContent;
